import { SHELL, INSET_X, LINE } from '@/components/base/Frame';
import SectionLabel from '@/components/base/SectionLabel';
import ErrorBoundary from '@/components/base/ErrorBoundary';
import Chapter from './Chapter';
import RoutingSystem from './RoutingSystem';

export default function RoutingSection() {
  return (
    <Chapter id="routing">
      <div className={`${SHELL} flex flex-col`}>
        <div className={`flex flex-col gap-3 bg-primary-50/70 pt-10 pb-8 md:pt-14 md:flex-row md:items-end md:justify-between md:pb-10 ${INSET_X}`}>
          <div>
            <SectionLabel index="03" label="Request routing system" />
            <h2 className="mt-4 text-3xl font-light leading-[1.1] tracking-[-0.02em] text-foreground-950 lg:text-[clamp(30px,2.9vw,42px)]">
              From request to resolution.
            </h2>
          </div>
          <p className="max-w-[24rem] text-sm font-light leading-relaxed text-foreground-600 md:text-right">
            Routine requests move forward automatically. Exceptions stay with people.
          </p>
        </div>
        <div className={`border-t ${LINE}`}>
          <ErrorBoundary>
            <RoutingSystem />
          </ErrorBoundary>
        </div>
        <p className={`border-t ${LINE} py-3 font-label text-[10px] uppercase tracking-[0.12em] text-foreground-500 ${INSET_X}`}>
          Illustrative workflow — not a client case
        </p>
      </div>
    </Chapter>
  );
}